import type { ViewIds } from '@ardoq/api-types';
import { viewSettingsConsts } from '@ardoq/view-settings';
import { getDefaultViewSettings } from 'views/environmentals/viewSettings/getDefaultViewSettings';
import {
  isViewpointModeView,
  isWorkspaceModeView,
} from 'views/environmentals/viewSettings/utils';
import type { SlideViewState } from './actions';

type SlideViewSettingsArgs = {
  viewId: ViewIds;
  viewState: SlideViewState;
  isViewpointMode: boolean;
  isLegendActive: boolean;
};

/**
 * The view settings a slide shows: its stored settings over the view's
 * defaults, so a setting the slide doesn't store doesn't carry over from the
 * slide shown before it.
 */
export const toSlideViewSettings = ({
  viewId,
  viewState,
  isViewpointMode,
  isLegendActive,
}: SlideViewSettingsArgs): Record<string, unknown> => {
  const defaultViewSettings =
    isViewpointModeView(viewId) || isWorkspaceModeView(viewId)
      ? getDefaultViewSettings(viewId, isViewpointMode)
      : {};
  const storedSettings: Record<string, unknown> = viewState;
  return {
    ...defaultViewSettings,
    ...storedSettings,
    collapsedGroupIds: storedSettings.collapsedGroupIds ?? [],
    [viewSettingsConsts.IS_LEGEND_ACTIVE]: isLegendActive,
  };
};
